import { ApiService } from './api.service';
import { Student } from '@/models/student/student';
import { StudentKartePrevNext } from '@/models/student/student';
import { PagingData } from '@/models/core/paging-data';
import { Empty } from '@/models/core/empty';
import { ImportStudentResults } from '@/models/student/import-students-result';
import { StudentGoodPoints } from '@/models/student/good-points';
import { UpdateCount, UpdateStudentProfilesRequest } from '@/models/student/students-arrange';
import { StudentPromotionRequest } from '@/models/student/student-promotion-request';
import { DataList } from '@/models/core/data-list';
import { ExistStudentResponse } from '@/models/student/exist-student-response';
import { CheckStudentDifferencesResult } from '@/models/student/check-student-differences-result';
import { GEnum } from '@/constants/enum.defination';
class StudentService extends ApiService {
  constructor() {
    super();
  }

  getStudents(
    targetType?: number,
    targetID?: number,
    limit: number = 15,
    offset: number = 0,
    sortKey: GEnum.StudentSortKey = GEnum.StudentSortKey.Grade,
    sortType: GEnum.SortType = GEnum.SortType.Asc,
    keyword: string = '',
    tagIDs?: string,
    hasScore: boolean = false,
    studentNumber: string = ''
  ): Promise<PagingData<Student>> {
    return this.getPagingData(Student, 'students', {
      targetType,
      targetID,
      limit,
      offset,
      sortKey,
      sortType,
      keyword,
      tagIDs,
      hasScore,
      studentNumber,
    });
  }

  getStudent(studentID: number = 1, headers: any): Promise<Student> {
    return this.get(Student, `students/${studentID}`, {}, headers);
  }

  updateStudent(params: object, id: number): Promise<Student> {
    return this.put(Student, `/students/${id}`, params);
  }

  updatePassword(params: object, id: number): Promise<Empty> {
    return this.put(Empty, `/students/${id}/password`, params);
  }

  deleteStudent(studentID: number): Promise<Empty> {
    return this.delete(`/students/${studentID}`, {});
  }

  checkStudentDifferences(params: FormData, canChangePassword: boolean): Promise<CheckStudentDifferencesResult> {
    return this.postFile(CheckStudentDifferencesResult, `/students/checkDifferences?canChangePassword=${canChangePassword}`, params);
  }

  sendStudentExcelFile(params: FormData, canChangePassword: boolean): Promise<ImportStudentResults> {
    return this.postFile(ImportStudentResults, `/students/import?canChangePassword=${canChangePassword}`, params);
  }

  loadStudentExcelFile(params: FormData): Promise<Student[]> {
    return this.loadExcelFile(Student, '/students/load', params);
  }

  downloadStudentRegistrationTemplate(): Promise<Blob> {
    return this.downloadFile('students/template', {});
  }

  downloadStudentsExcelFile(targetType?: number, targetID?: number, keyword: string = '', studentNumber?: string, tagIDs?: string): Promise<Blob> {
    return this.downloadFile('students/download', { targetType, targetID, keyword, studentNumber, tagIDs });
  }

  fetchGoodPoints(studentID: number): Promise<StudentGoodPoints> {
    return this.get(StudentGoodPoints, `students/${studentID}/goodPoints`, {});
  }

  updateStudentProfiles(params: DataList<UpdateStudentProfilesRequest>): Promise<UpdateCount> {
    return this.put(UpdateCount, '/students/profiles', params);
  }

  promoteStudents(params: DataList<StudentPromotionRequest>): Promise<Empty> {
    return this.post(Empty, '/students/promote', params);
  }

  existStudent(studentID: number, headers?: any): Promise<ExistStudentResponse> {
    return this.get(ExistStudentResponse, `/students/${studentID}/exist`, {}, headers);
  }

  downloadFindingsProposalsList(targetType?: number, targetID?: number, keyword: string = '', tagIDs?: string): Promise<Blob> {
    return this.downloadFile('students/findingsProposals', { targetType, targetID, keyword, tagIDs });
  }

  fetchStudentKartePrevNext(
    studentID: number,
    targetType?: number,
    targetID?: number,
    sortKey: GEnum.StudentSortKey = GEnum.StudentSortKey.Grade,
    sortType: GEnum.SortType = GEnum.SortType.Asc,
    keyword: string = '',
    tagIDs?: string,
    hasScore: boolean = true,
    studentNumber: string = ''
  ): Promise<StudentKartePrevNext> {
    return this.get(StudentKartePrevNext, `/students/${studentID}/prevNext`, {
      targetType,
      targetID,
      sortKey,
      sortType,
      keyword,
      tagIDs,
      hasScore,
      studentNumber,
    });
  }
}
export const studentService = new StudentService();
